import React from "react";

import * as Sentry from "@sentry/react";
import { AcceptancePageProps } from "./types";
import { Brand } from "@ds-developer/models";
import { ErrorGeneric } from "@hubcapp/views";
import { Header } from "./components";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    "&.aa": {
      background: "#f6f6f6",
    },
    "&.bsm": {
      background: "#F8F7F9",
    },
  },
  main: {
    margin: "40px 100px",
    [theme.breakpoints.down("sm")]: {
      margin: "20px 16px",
    },
  },
}));

const AcceptancePage: React.FC<AcceptancePageProps> = ({
  brand,
  headerTitle,
  children,
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, brand === Brand.Bsm ? "bsm" : "aa")}>
      <Header brand={brand} title={headerTitle}></Header>
      <main className={classes.main}>
        <Sentry.ErrorBoundary
          fallback={
            <div style={{ flex: 1 }}>
              <ErrorGeneric />
            </div>
          }
        >
          {children}
        </Sentry.ErrorBoundary>
      </main>
    </div>
  );
};

export default AcceptancePage;
